import { modalSupprimerInterlocuteur } from '../../../pages/interlocuteurs-coupures/main.js';
import { PageManager } from '../../services/page-manager.js';
import { PageTypes } from '../../services/settings-loader.js';
import { TagCommanderManager } from '../../services/tag-commander-manager';
import MicroApp from './micro-app-base';

/**
 * Microapp interlocuteurs de coupures
 */
export default class InterlocuteursCoupuresMicroApp extends MicroApp {
  isDesignSystemSource = true;
  /**
   * Surcharge pour réagir aux messages de la microapp
   */
  childPymEvents = {
    openModalSupprimerInterlocuteur: function (codeService) {
      if (codeService === 'COUPURE') {
        TagCommanderManager.tagPage({
          chapitre_1: 'mon_reseau_electrique',
          chapitre_2: 'interlocuteurs_prevenance',
          chapitre_3: 'voir_interlocuteur',
          page: 'suppression_interlocuteur_hta',
        });
      }
      else if (codeService === 'PCP') {
        TagCommanderManager.tagPage({
          chapitre_1: 'mon_reseau_electrique',
          chapitre_2: 'interlocuteurs_prevenance',
          chapitre_3: 'voir_interlocuteur',
          page: 'suppression_interlocuteur_travaux',
        });
      }
      modalSupprimerInterlocuteur.setCodeService(codeService);
      modalSupprimerInterlocuteur.show();
    },
    supprimerInterlocuteurSucces: function () {
      let myToast = document.querySelector('huitab-toast');
      myToast.classList.add('toast-interlocuteurs');
      myToast.setToast("L'interlocuteur a été supprimé avec succès", 'true', '2000', 'vert-700', 'check');
      myToast.show();
    },
    validerDeclarationSucces: function () {
      let myToast = document.querySelector('huitab-toast');
      myToast.classList.add('toast-interlocuteurs');
      myToast.setToast("L'interlocuteur a été ajouté avec succès", 'true', '2000', 'vert-700', 'check');
      myToast.show();
    },
    validerModificationSucces: function () {
      let myToast = document.querySelector('huitab-toast');
      myToast.classList.add('toast-interlocuteurs');
      myToast.setToast("L'interlocuteur a été modifié avec succès", 'true', '2000', 'vert-700', 'check');
      myToast.show();
    },
    pretLancerRecherche: function () {
      const lncWebRechercheInterlocuteurs = document.querySelector(
        '#bloc-critere-recherche lnc-web-recherche-interlocuteurs',
      );
      if (lncWebRechercheInterlocuteurs) {
        const searchClickEvent = new CustomEvent('searchClick', { detail: { prm: [], siren: '', siret: [] } });
        lncWebRechercheInterlocuteurs.dispatchEvent(searchClickEvent);
      }
    },
    gererInterlocuteursEnMasse: function () {
      PageManager.redirectTo(PageTypes.GESTION_INTERLOCUTEURS_EN_MASSE);
    },
  };

  /**
   * Initialise une nouvelle instance de type {@type InterlocuteursCoupuresMicroApp}.
   */
  constructor() {
    super();

    if (!this.isMicroappAlive) {
      TagCommanderManager.tagClick({
        chapitre_1: 'mon_reseau_electrique',
        chapitre_2: 'interlocuteurs_prevenance',
        page: 'erreur_technique_survenue',
      });
    }
  }
}
